import { NUMBER_OF_SECONDS_IN_DAY } from "./magicNumbers";
import timeUtils from "./timeUtils";

const widgetColourStatus = ({
  remaining,
  title,
  calendarDaysAmberLimit = 30,
  calendarSecondsAmberLimit = 36000,
  isDateTime = false,
  nextDue = null,
  threshold,
}: {
  remaining: number;
  title: string;
  calendarDaysAmberLimit?: number;
  calendarSecondsAmberLimit?: number;
  isDateTime?: boolean;
  nextDue?: string;
  threshold: number;
}): string => {
  if (remaining === null || title === null) return '';

  let colourStatus = 'open';

  if (isDateTime && !nextDue) return 'open';

  if (remaining <= 0) {
    colourStatus = 'overdue';
  } else if (title === 'Cycles' && remaining <= threshold) {
    colourStatus = 'critical';
  } else if (
    (title === 'Hours' || title === 'APU Hours') &&
    remaining <= threshold
  ) {
    colourStatus = 'critical';
  } else if (title === 'Days') {
    const daysRemaining = remaining;
    const daysLimit = calendarDaysAmberLimit ?? threshold;

    if (isDateTime && nextDue) {
      const daysLimitInSeconds =
        (calendarSecondsAmberLimit ?? (threshold * NUMBER_OF_SECONDS_IN_DAY));
      const daysRemainingInSeconds = timeUtils.getSecondsFromNow(nextDue);

      if (daysRemainingInSeconds < daysLimitInSeconds) {
        colourStatus = 'critical';
      }
    } else if (daysRemaining < daysLimit) {
      colourStatus = 'critical';
    }
  }
  return colourStatus;
};

export default widgetColourStatus;
